"use client";

import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import PhoneInput from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import ThemeInput from "../components/ThemeComponent/ThemeInput";
import {
  AuthHeadingText,
  PageHeading,
} from "../components/ThemeComponent/ThemeText";
import { validation, validationText } from "../utils/constants.js";
import { errorToast, success } from "../utils/helpers.js";
import { useUpdateProfileMutation } from "../Redux/services/userAuthApi.js";
import ThemeSpinner from "../components/ThemeComponent/ThemeSpinner";

const Settings = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentPassword, setCurrentPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [cnfrmShowPassword, setCnfrmShowPassword] = useState(false);
  const [number, setNumber] = useState("");
  const user = useSelector((state) => state.authInfo.user);

  const handleCurrentPassword = () => {
    setCurrentPassword(!currentPassword);
  };
  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleShowCnfrmPassword = () => {
    setCnfrmShowPassword(!cnfrmShowPassword);
  };
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const [updateProfile, { isLoading }] = useUpdateProfileMutation();

  const options = [
    { label: "Doctor", value: "1" },
    { label: "Helper", value: "2" },
    { label: "Nurse", value: "3" },
  ];

  const onSubmit = async (data) => {
    // const payload = { ...data, id: user?.id };
    const payload = { ...data, mobile_no: number };
    delete payload.email;
    try {
      let response = await updateProfile(payload);

      if (response.data.code === 200) {
        success(response?.data?.message);
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      }
    }
  };

  useEffect(() => {
    if (user) {
      setValue("name", user.name);
      setValue("email", user.email);
      setValue("mobile_no", user.mobile_no);
      setValue("username", user.username);
      setValue("password", user.password_view);
      setValue("designation", user.designation);
    } else {
      reset();
    }
  }, []);
  return (
    <div className="dashboard-page patient-page">
      <div className="header d-lg-flex justify-content-between">
        <PageHeading text={"Settings"} />
      </div>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-edit-profile mt-2 bg-white p-3 rounded-3"
      >
        <AuthHeadingText
          text="Profile Details"
          className={"mb-1 fw-bolder fs-6"}
        />
        <ThemeInput
          name="name"
          errors={errors}
          control={control}
          type={"text"}
          className={""}
          placeholder={"First Name"}
          rules={{
            required: {
              value: true,
              message: validationText.nameRequired,
            },
            maxLength: {
              value: validation.nameMax,
              message: validationText.nameMax,
            },
          }}
        />

        <Row className={"mt-3 mb-5"}>
          <Col md={6}>
            <ThemeInput
              name="email"
              errors={errors}
              control={control}
              type={"email"}
              className={""}
              placeholder={"Email Address"}
              rules={{
                required: {
                  value: true,
                  message: validationText.emailRequired,
                },
                maxLength: {
                  value: validation.emailMax,
                  message: validationText.emailMax,
                },
              }}
              disabled={true}
            />
          </Col>
          <Col md={6}>
            <div className="contact-input mb-3">
              <PhoneInput
                international
                countryCallingCodeEditable={false}
                defaultCountry="RU"
                value={number}
                onChange={setNumber}
                errors={errors}
                limitMaxLength={8}
                name="mobile_no"
              />
            </div>
          </Col>
        </Row>
        <hr />

        <AuthHeadingText
          text="Change Password"
          className={"mb-2 mt-5 fw-bolder fs-6"}
        />
        <Row className={""}>
          <Col md={4}>
            <div className="password-input mb-3">
              <ThemeInput
                name="password"
                control={control}
                errors={errors}
                rules={{
                  required: {
                    value: true,
                    message: validationText.passwordRequired,
                  },
                  minLength: {
                    value: validation.passwordMin,
                    message: validationText.passwordMin,
                  },
                  maxLength: {
                    value: validation.passwordMax,
                    message: validationText.passwordMax,
                  },
                  // pattern: {
                  //   value:
                  //     /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/,
                  //   message:
                  //     "At least one letter, one number, one special character",
                  // },
                }}
                label=""
                placeholder="Current Password"
                type={currentPassword ? "text" : "password"}
                minLength={validation.passwordMin}
                maxLength={validation.passwordMax}
              />
              <span className="icon cursor" onClick={handleCurrentPassword}>
                {currentPassword ? (
                  <VscEyeClosed className="text-black" />
                ) : (
                  <VscEye className="text-black" />
                )}
              </span>
            </div>
          </Col>

          <Col md={4}>
            <div className="password-input mb-3">
              <ThemeInput
                name="new_password"
                control={control}
                errors={errors}
                rules={{
                  required: {
                    value: true,
                    message: validationText.passwordRequired,
                  },
                  minLength: {
                    value: validation.passwordMin,
                    message: validationText.passwordMin,
                  },
                  maxLength: {
                    value: validation.passwordMax,
                    message: validationText.passwordMax,
                  },
                  pattern: {
                    value:
                      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/,
                    message:
                      "At least one letter, one number, one special character",
                  },
                }}
                label=""
                placeholder="New Password"
                type={showPassword ? "text" : "password"}
                minLength={validation.passwordMin}
                maxLength={validation.passwordMax}
              />
              <span className="icon cursor" onClick={handleShowPassword}>
                {showPassword ? (
                  <VscEyeClosed className="text-black" />
                ) : (
                  <VscEye className="text-black" />
                )}
              </span>
            </div>
          </Col>

          <Col md={4}>
            <div className="password-input mb-2">
              <ThemeInput
                name="confirm_password"
                control={control}
                errors={errors}
                rules={{
                  required: {
                    value: true,
                    message: validationText.passwordRequired,
                  },
                  minLength: {
                    value: validation.passwordMin,
                    message: validationText.passwordMin,
                  },
                  maxLength: {
                    value: validation.passwordMax,
                    message: validationText.passwordMax,
                  },
                  pattern: {
                    value:
                      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/,
                    message:
                      "At least one letter, one number, one special character",
                  },
                }}
                label=""
                placeholder="Confirm New Password"
                type={cnfrmShowPassword ? "text" : "password"}
                minLength={validation.passwordMin}
                maxLength={validation.passwordMax}
              />
              <span className="icon cursor" onClick={handleShowCnfrmPassword}>
                {cnfrmShowPassword ? (
                  <VscEyeClosed className="text-black" />
                ) : (
                  <VscEye className="text-black" />
                )}
              </span>
            </div>
          </Col>
        </Row>

        <div className="d-flex gap-3 mt-4 w-100 justify-content-end">
          <div className="btn-submit w-25">
            <Button
              disabled={isLoading}
              type="submit"
              className="theme-btn w-100"
            >
              {isLoading ? <ThemeSpinner /> : "Save Changes"}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Settings;
